import { Column, Screen } from '@tempmee/react';
import { BackButton } from '~/commonComponents/BackButton';
import { NoScreen } from '~/components/shared/NoScreen';
import { ShiftPendingReviews } from './ShiftPendingReviews';

export const ShiftPendingReviewsScreen = () => (
  <NoScreen>
    <Screen.Header start={<BackButton />} title="Pending Review" />
    <Column width="100%">
      <ShiftPendingReviews />
    </Column>
  </NoScreen>
);
